<template>
  <div class="container-fluid">
    <h1>Помощь</h1>
  </div>
</template>

<script>
  export default {
    data: () => ({}),
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/help.vue